import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

@Component({
  selector: 'app-panel-tabs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="panel-tabs__bar" role="tablist">
      @for (tab of tabs(); track tab) {
        <button
          class="panel-tabs__tab"
          role="tab"
          type="button"
          [attr.data-active]="active() === tab"
          [attr.aria-selected]="active() === tab"
          (click)="active.set(tab)"
        >
          {{ tab }}
        </button>
      }
    </div>
  `,
  styleUrl: './panel-tabs.component.scss',
})
export class PanelTabsComponent {
  tabs = input.required<string[]>();
  active = model('');
}
